import { render } from "./CompanyInvestment.vue?vue&type=template&id=63717f81"
import script from "./CompanyInvestment.vue?vue&type=script&lang=js"
export * from "./CompanyInvestment.vue?vue&type=script&lang=js"

import "./CompanyInvestment.vue?vue&type=style&index=0&id=63717f81&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__